// extracted by mini-css-extract-plugin
module.exports = {"centerDiv":"search_centerDiv__OVmZx","searchBox":"search_searchBox__3gHtF","loader-box":"search_loader-box__3PyVb"};